export default "__VITE_ASSET__ef097f7b__"